import { IAnswerRecord } from '@/contracts/modules/education/entities/IAnswerRecord'

/** Строка факта ответа из ответа узла (201) */
export class AnswerRecord implements IAnswerRecord {
  time: string
  at: string
  question: string
  node: string
  result: boolean
  ms: number
  pack: string

  constructor({ time, at, question, node, result, ms, pack }: IAnswerRecord) {
    this.time = time
    this.at = at
    this.question = question
    this.node = node
    this.result = result
    this.ms = ms
    this.pack = pack
  }
}
